import * as React from 'react';
import { getLayerIcon, getLayerObject } from 'selectors';
import { useSelector } from 'react-redux';
import { IObjectSignature } from 'types';
import { IState } from 'services/root-reducer';
import { ObjectsHelper } from 'utils';
import { IDisplayConfigItem } from './index';

interface FavoritesDetalizationObjectProps {
    objectSignature: IObjectSignature;
    displayConfig: IDisplayConfigItem;
}

export const FavoritesDetalizationObject = (props: FavoritesDetalizationObjectProps) => {
    let layer_icon = useSelector((state: IState) => getLayerIcon(state, props.objectSignature));

    let object = useSelector((state: IState) => getLayerObject(
        state,
        props.objectSignature.layer_code,
        props.objectSignature.object_id
    ));

    // По идее такого быть не должно, но на пожарный случай
    if (!object) {
        console.log(
            'Не смогли отрендерить',
            `layer_code=${props.objectSignature.layer_code}`,
            `object_id=${props.objectSignature.object_id}`
        );
        return null;
    }

    return (
        <div className="detalization-item-object">
            <div
                className="detalization-item-object-layer-icon"
                style={{
                    backgroundImage: `url(${layer_icon})`
                }}
            />
            <div className="detalization-item-object-name">
                {/* <a */}
                {/*    target='_blank' */}
                {/*    rel='noopener noreferrer' */}
                {/*    href={props.displayConfig.CONTENT_URL + props.objectSignature.object_id} */}
                {/* > */}
                <span
                    dangerouslySetInnerHTML={{
                        __html: object.get(props.displayConfig.FIELD_NAME)
                    }}
                />
                {/* </a> */}
            </div>
        </div>
    );
};
